import {DriverVehicleReservationStatusEnum} from '@/services/api-clients';

export function driverVehicleReservationStatusColorFilter(value: DriverVehicleReservationStatusEnum): string[] {
  switch (value) {
    case DriverVehicleReservationStatusEnum.Waiting: return ['primary', 'primary--text'];
    case DriverVehicleReservationStatusEnum.Approved: return ['success', 'success--text'];
    case DriverVehicleReservationStatusEnum.Cancelled: return ['error', 'error--text'];
  }
}
